import React from 'react';
import { Placeholder, Text } from '@stitch-fix/mode-react';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';
import ShippingDetails from '../ShippingDetails/ShippingDetails';

/**
 * Displays "Shipping & Returns" details and links for the PDP
 */
const ShippingDetailsForPDP = () => {
  const [state] = useProductDetailsPageContext();

  return state.loading || !state.shopProduct ? (
    <Text color="gray-16" setting="title-medium">
      <Placeholder maxWidth={18} />
    </Text>
  ) : (
    <ShippingDetails />
  );
};

export default ShippingDetailsForPDP;
